import { createSelector } from 'reselect'
import _ from 'lodash'

import jsonSelector from './json'

const currentUserSelector = jsonSelector('users.current.index')

const referral_link = current_user => {
  const { protocol, host } = window.location
  return `${protocol}//${host}/?ref=${current_user.referral_uuid}`
}

export default createSelector(currentUserSelector, json =>
  _.assign({}, json, {
    referral_link: referral_link(json),
    full_name: _.compact([json.name, json.middle_name, json.last_name]).join(' ')
  })
)



// WEBPACK FOOTER //
// ./src/selectors/current_user.js